import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useState } from "react";
import { useDownloadPayrollsDataMutation, useLazyGetPayRollDataQuery,useLazyGetPayRollDataByEmployeesQuery } from "../api/payRollApi";
import { saveAs } from 'file-saver';
// import { downloadBlobFile } from "../services/downloadFile";
import { toast } from "react-toastify";
import ExportPayroll from "./ExportPayroll";
const PayRollTable = () => {
  const today = dayjs();
  const [selectedDate, setSelectedDate] = useState(today);
  const [fetchPayrollData, { isFetching }] = useLazyGetPayRollDataQuery();
    const [getPayRollDataByEmployees, { isFetching: isFetchingByEmployees }] = useLazyGetPayRollDataByEmployeesQuery();

  const [downloadPayrollXl] = useDownloadPayrollsDataMutation()
  const [payrollData, setPayrollData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const getPayrollData = async () => {
    const date = dayjs(selectedDate).format("YYYY-MM-DD");
    try {
      const res = await fetchPayrollData({
        payrollProcessedDate: date,
      }).unwrap();
      const response = await getPayRollDataByEmployees({
        payrollProcessedDate: date,
      }).unwrap();
      if(res.data.length === 0){
        toast.info("No Employee Data Found for this Date")
      }
      setEmployeeData(response.data);
      setPayrollData(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const exportPayrollData = async () => {
    const payrollProcessedDate = dayjs(selectedDate).format("YYYY-MM-DD");
    try {
        const response = downloadPayrollXl({payrollProcessedDate}).unwrap()
        let fileName = `payrolls_${payrollProcessedDate}.csv`;
        // response?.data && downloadBlobFile(response?.data,fileName);
        // const blob = new Blob([response.data]);
        saveAs(response?.data, fileName);
    } catch (error) {  
        console.error(error)
    }
  };


  const renderTable = (isProcessed) => {
    const filteredPayrollData = payrollData.filter(
      (each) => each.processedEmployee === isProcessed
    );
    
    if (!filteredPayrollData.length) {
      return (
        <div className="flex flex-col items-center justify-center py-12 text-gray-500">
          <p className="text-lg font-medium">No Data Found</p>
          <p className="text-sm">No employees found for this category</p>
        </div>
      );
    }

    return (
      <div className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200">
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Employee Name
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Processed Date
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Email
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredPayrollData.map((employee, index) => (
                <tr key={employee._id} className="hover:bg-gray-50 transition-colors duration-150">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="ml-3">
                        <div className="text-sm font-medium text-gray-900">
                          {employee.employeeDisplayName}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center text-sm text-gray-900">
                      {dayjs(employee.payrollProcessedDate).format('MMM DD, YYYY')}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {employee.professionalEmail || (
                      <span className="text-gray-400 italic">No email provided</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const processedCount = payrollData.filter(emp => emp.processedEmployee).length;
  const unprocessedCount = payrollData.filter(emp => !emp.processedEmployee).length;

  return (
    <div className="max-w-7xl mx-auto p-6 bg-gray-50 min-h-screen">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-end">
          <div className="flex-1 max-w-xs">
            <label className="block text-sm font-medium text-gray-700 mb-5">
              Select Payroll Period
            </label>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="PayRoll Date"
                value={selectedDate}
                className="w-full"
                format="MM/YYYY"
                views={["month", "year"]}
                onChange={handleDateChange}
                disableFuture
                slotProps={{
                  textField: {
                    readOnly: true,
                    size: "small"
                  },
                }}
              />
            </LocalizationProvider>
          </div>
          
          <div className="flex gap-3">
            <button
              className="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white px-6 py-2.5 rounded-lg font-medium transition-colors duration-200 flex items-center gap-2"
              disabled={!selectedDate || isFetching}
              onClick={getPayrollData}
            >
              {isFetching ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                  Loading...
                </>
              ) : (
                <>
                  Get Payroll Data
                </>
              )}
            </button>
            
            {payrollData.filter(emp => emp.processedEmployee).length > 0 && (
              <ExportPayroll data={employeeData} />
            )}
          </div>
        </div>
      </div>

      {payrollData.length > 0 && (
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="bg-green-50 border-b border-green-200 px-6 py-4">
              <div className="flex items-center gap-3">
                <h3 className="text-lg font-semibold text-green-800">
                  Processed Employees ({processedCount})
                </h3>
              </div>
            </div>
            {renderTable(true)}
          </div>

          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="bg-yellow-50 border-b border-yellow-200 px-6 py-4">
              <div className="flex items-center gap-3">
                <h3 className="text-lg font-semibold text-yellow-800">
                  Pending Employees ({unprocessedCount})
                </h3>
              </div>
            </div>
            {renderTable(false)}
          </div>
        </div>
      )}

      {payrollData.length === 0 && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-12 text-center">
          <h3 className="text-lg font-medium text-gray-900 mb-2">No Payroll Data</h3>
          <p className="text-gray-500 mb-6">Select a date and click "Get Payroll Data" to view employee information</p>
        </div>
      )}
    </div>
  );
};

export default PayRollTable;